export const actions = {
  SET_IMAGE_NOTE: "SET_IMAGE_NOTE",
};

export const saveNote = (note) => ({
  type: actions.SET_IMAGE_NOTE,
  note,
});